import {
    PAGETHREE
} from "../../../constants"



const initialState = {
    data: []
}


export default(state = initialState, action) => {
    switch (action.type) {
        case PAGETHREE: {
            return {
                ...initialState,
                data: action.payload
            }
        }
        default: {
            return state
        }
    }
}